import { Provider } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Store } from '@reduxjs/toolkit';

import RecordController from '~/App/Controllers/RecordController';
import Questionnaire, { QuestionnaireProps } from './Questionnaire';

export default function QuestionnaireProvider({
  questionId,
  hideQuestionHeader,
}: QuestionnaireProps) {
  const [store, setStore] = useState<Store<Record<string, unknown>>>();

  useEffect(() => {
    async function bootstrap() {
      setStore(await new RecordController().record());
    }

    bootstrap();
  }, []);

  if (!store) {
    return null;
  }

  return (
    <Provider store={store}>
      <Questionnaire
        questionId={questionId}
        hideQuestionHeader={hideQuestionHeader}
      />
    </Provider>
  );
}
